import { useState, KeyboardEvent } from 'react';

interface GHLTagsInputProps {
  tags: string[];
  setTags: (tags: string[]) => void;
}

export default function GHLTagsInput({ tags, setTags }: GHLTagsInputProps) {
  const [inputValue, setInputValue] = useState('');

  const handleAddTag = () => {
    const cleanTag = inputValue.trim().toLowerCase();
    if (cleanTag && !tags.includes(cleanTag) && /^[a-z0-9_-]+$/i.test(cleanTag)) {
      setTags([...tags, cleanTag]);
    }
    setInputValue('');
  };

  const handleRemoveTag = (tagToRemove: string) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="mt-4">
      <label className="block text-sm font-medium">GHL Tags:</label>

      <div className="flex gap-2 flex-wrap mb-2">
        {tags.map((tag, index) => (
          <span
            key={`${index}-${tag}`}
            className="inline-flex items-center bg-gray-200 text-gray-800 rounded-full px-3 py-1 text-xs"
          >
            {tag}
            <button
              type="button"
              onClick={() => handleRemoveTag(tag)}
              className="ml-2 rounded text-gray-500 hover:text-[#EE3333] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[#EE3333]"
              aria-label={`Remove ${tag}`}
              title="Remove"
            >
              &times;
            </button>
          </span>
        ))}
      </div>

      <input
        type="text"
        placeholder="Add a tag and press Enter"
        value={inputValue}
        onChange={(e) => {
          const raw = e.target.value;
          const cleaned = raw.replace(/[^a-z0-9_-]/gi, '');
          setInputValue(cleaned);
        }}
        onKeyDown={handleKeyDown}
        className="w-full border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#EE3333] focus:ring-1 focus:ring-[#EE3333]"
      />
    </div>
  );
}
